import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { signupError } from '../components/signup/SignupStatus';
import './signup.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth/password-reset`;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [done, setDone] = useState(false);

  const requestLink = async event => {
    event.preventDefault();
    setBusy(true); setError(''); setNotice('');
    try {
      const { data } = await axios.post(`${API}/request`, { email: email.trim().toLowerCase() });
      setNotice(data.message);
    } catch (failure) {
      setError(signupError(failure));
    } finally { setBusy(false); }
  };

  const setNewPassword = async event => {
    event.preventDefault();
    setError('');
    if (password !== confirm) { setError('Нууц үг таарахгүй байна.'); return; }
    if (unescape(encodeURIComponent(password)).length > 72) { setError('Нууц үг UTF-8-аар 72 байтаас ихгүй байна.'); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/confirm`, { token, new_password: password });
      setNotice(data.message); setDone(true); setPassword(''); setConfirm('');
    } catch (failure) {
      setError(signupError(failure));
    } finally { setBusy(false); }
  };

  return <main className="signup-page" data-testid="reset-password-page">
    <header className="signup-header">
      <Link to="/" className="signup-brand">RENTOS</Link>
      <Link to="/" data-testid="reset-login-link" className="signup-back"><ArrowLeft size={16} />Нэвтрэх</Link>
    </header>
    <section className="signup-content">
      <h1>{token ? 'Шинэ нууц үг' : 'Нууц үг сэргээх'}</h1>
      <p className="signup-subtitle">{token ? 'Шинэ нууц үгээ хоёр удаа оруулна уу.'
        : 'Бүртгэлтэй email хаягаа оруулбал нууц үг сэргээх холбоос илгээнэ.'}</p>
      {error && <div data-testid="reset-error" role="alert" className="signup-error">{error}</div>}
      {notice && <div data-testid="reset-notice" role="status" className="signup-notice">{notice}</div>}
      {done ? <Link to="/" data-testid="reset-done-login" className="signup-back">Нэвтрэх хуудас руу <ArrowLeft size={16} /></Link>
        : token ? <form onSubmit={setNewPassword} className="signup-fields" data-testid="reset-confirm-form">
          <div className="signup-wide">
            <Label htmlFor="reset-password">Шинэ нууц үг</Label>
            <Input id="reset-password" data-testid="reset-password-input" type="password" autoComplete="new-password"
              required minLength={8} maxLength={72} value={password} disabled={busy}
              onChange={event => setPassword(event.target.value)} />
          </div>
          <div className="signup-wide">
            <Label htmlFor="reset-password-confirm">Нууц үг давтах</Label>
            <Input id="reset-password-confirm" data-testid="reset-password-confirm-input" type="password"
              autoComplete="new-password" required minLength={8} maxLength={72} value={confirm} disabled={busy}
              onChange={event => setConfirm(event.target.value)} />
          </div>
          <Button type="submit" data-testid="reset-confirm-btn" disabled={busy} className="signup-wide signup-primary">
            {busy ? 'Хадгалж байна…' : 'Нууц үг хадгалах'}
          </Button>
        </form>
        : <form onSubmit={requestLink} className="signup-fields" data-testid="reset-request-form">
          <div className="signup-wide">
            <Label htmlFor="reset-email">Email</Label>
            <Input id="reset-email" data-testid="reset-email-input" type="email" autoComplete="email" required
              maxLength={254} value={email} disabled={busy} onChange={event => setEmail(event.target.value)} />
          </div>
          <Button type="submit" data-testid="reset-request-btn" disabled={busy} className="signup-wide signup-primary">
            {busy ? 'Илгээж байна…' : 'Холбоос илгээх'}
          </Button>
        </form>}
    </section>
  </main>;
}
